import { createFileRoute } from "@tanstack/react-router";
import CompleteProfileForm from "@/components/profiles/complete-profile-form";

export const Route = createFileRoute("/_authenticated/complete-profile")({
  component: CompleteProfilePage,
});

function CompleteProfilePage() {
  return (
    <div>
      <CompleteProfileForm />
    </div>
  );
}
